import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  body: {
    padding: '30px',
  },
  image: {
    textAlign: 'left',
    width: '172px',
    height: '75px',
    padding: '0px',
  },
  newImage: {
    textAlign: 'left',
    width: '220px',
    height: '70px',
    padding: '0px',
    marginLeft: '-20px',
  },
  address: {
    fontSize: '14px',
    textAlign: 'right',
    marginRight: '50px',
    fontFamily: 'Times-Bold',
  },
  content: {
    fontSize: '12px',
    marginRight: '50px',
    textAlign: 'right',
    marginBottom: '4px',
    fontFamily: 'Times-Roman',
  },
  objectView: {
    border: '2px solid black',
    padding: '5px',
    marginTop: '20px',
    marginBottom: '20px',
  },
  manager: {
    fontSize: '14px',
    marginRight: '50px',
    marginTop: '40px',
    textAlign: 'right',
    fontFamily: 'Times-Roman',
  },
  mission: {
    fontSize: '14px',
    textAlign: 'left',
    marginBottom: '4px',
    fontFamily: 'Times-Roman',
  },
  text: {
    margin: '50px',
    marginTop: '100px',
    marginLeft: 0,
    fontSize: '14px',
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
  },
  contentBody: {
    marginTop: '15px',
    marginLeft: 0,
    fontSize: '14px',
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
  },
  pj: {
    fontSize: '14px',
    marginTop: '-10px',
    marginLeft: 0,
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
  },
  footer: {
    fontSize: '9px',
    marginRight: '50px',
    marginTop: '40px',
    marginBottom: '10px',
    textAlign: 'left',
  },
  nota: {
    fontSize: '14px',
    marginTop: '90px',
    marginRight: '50px',
    marginLeft: 0,
    textAlign: 'left',
    fontFamily: 'Times-Roman',
  },
  newFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    color: '#000',
    textAlign: 'left',
    marginTop: '120px',
    lineHeight: 0.8,
  },
  newFooterletter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    color: '#000',
    textAlign: 'left',
    marginTop: '100px',
    lineHeight: 0.8,
  },
  newFooterLeft: {
    flex: 1,
    paddingRight: 10,
  },
  newFooterLine1: {
    fontSize: 10,
  },
  newFooterLine2: {
    fontSize: 7.5,
  },
  newFooterBold: {
    fontWeight: 'bold',
  },
  newFooterLegal: {
    fontSize: 6.5,
  },
  newFooterRight: {
    width: 100,
    paddingTop: 12,
  },
  newFooterContactRow: {
    flexDirection: 'row',
    fontSize: 7.5,
  },
  newFooterContactLabel: {
    width: 18,
    fontWeight: 'bold',
  },
  newFooterWeb: {
    fontSize: 7.5,
    marginLeft: 18,
  },
});
